import { Card, Tabs, Table, Row, Col, Tag, Form, Input, Button, Switch, Menu, Upload, Progress, Modal, Skeleton, Select, Image, Space, List, Divider, InputNumber, DatePicker, Carousel } from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { useEffect, useState, useCallback, useRef } from "react";
// import Clock from 'react-live-clock';
import { formatCurrency } from '../common/Format'
import {
    AppstoreOutlined, SettingOutlined, DeleteOutlined, FormOutlined, CloseCircleOutlined, PlusOutlined, BgColorsOutlined,
    MenuOutlined,
} from "@ant-design/icons";
import swal from "sweetalert";

import { Editor } from '@tinymce/tinymce-react';
import 'moment/locale/vi';
import { HexColorPicker } from "react-colorful";

import ButtonGroup from "antd/lib/button/button-group";
import moment from "moment";
import axiosClient from "../../api/axios";
import { changeUpload, updateFileListFromUrls, uploadImage, beforeUpload, getFilePreview } from '../common/Upload/upload.js'
import limitString from "../common/LimitString/litmitstring";
import LinkUpload from "../../api/LinkUpload";




const { TabPane } = Tabs;
const { Option } = Select;
const MarqueeManager = () => {
    const database = localStorage.getItem('DatabaseName');
    const token = localStorage.getItem('token');
    const IDAccount = localStorage.getItem('ID');
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const [formBackgrounds] = Form.useForm();
    const [formFilterBackgrounds] = Form.useForm()
    // Quản lý banner
    const [dataBackgrounds, setDataBackgrounds] = useState([]);
    const [openModalBackgrounds, setOpenModalBackgrounds] = useState(false);
    const [loadingBackgrounds, setLoadingBackgrounds] = useState(false);
    const [statusBackgrounds, setStatusBackgrounds] = useState(false);


    // upload image
    const [fileListBackgrounds, setFileListBackgrounds] = useState([]);
    const [fileList, setFileList] = useState([]);


    const showModalBackgrounds = (record) => {
        //const IDTemp = 0;
        setFileListBackgrounds([])
        formBackgrounds.resetFields();
        if (typeof record === 'object') {
            setLoadingBackgrounds(false)
            setStatusBackgrounds(true)
            updateFileListFromUrls(setFileListBackgrounds, record.Image)
            updateFileListFromUrls(setFileList, record.Logo)
            formBackgrounds.setFieldsValue(record);
            setOpenModalBackgrounds(true)
        }
        else {
            setLoadingBackgrounds(false)
            setStatusBackgrounds(false)
            updateFileListFromUrls(setFileListBackgrounds, '')
            updateFileListFromUrls(setFileList, '')
            formBackgrounds.setFieldsValue({
                "ID": 1,
                "Logo": "",
                "Image": "",
                "Note": "",
                "Color": "#000000",
                IsActive: true
            })
            setOpenModalBackgrounds(true)
        }


    }

    const onFinishBackgrounds = (values) => {
        setLoadingBackgrounds(true)
        if (statusBackgrounds === false) {
            axiosClient.post('/Backgrounds/AddBackgrounds', values, {
                headers: header
            }).then(res => {
                setLoadingBackgrounds(false)
                swal('Thành công!', {
                    icon: 'success'
                })
                formBackgrounds.resetFields();
                LoadDataBackgrounds();
                setOpenModalBackgrounds(false)
            })
        }
        else {

            axiosClient.post('/Backgrounds/UpdateBackgrounds', values, {
                headers: header
            }).then(res => {
                if (res.status === 200) {

                    setLoadingBackgrounds(false)
                    swal('Thành công!', {
                        icon: 'success'
                    })
                    formBackgrounds.resetFields();
                    LoadDataBackgrounds();
                    setOpenModalBackgrounds(false)
                }
            })
        }

    }
    
    const LoadDataBackgrounds = () => {
        axiosClient.post('/Backgrounds/GetBackgroundsAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataBackgrounds(res.data);
            }
        })
    }


    const [dataPermission, setDataPermission] = useState([]);
    const LoadDataPermission = () => {
        axiosClient.post('/Permissions/GetApiPermissionAll', '', { headers: header }).then(resPermiss => {
            setDataPermission(resPermiss.data);
        })
    }

    const renderBackgrounds = () => {
        return (
            <Form
                id="form-Backgrounds"
                form={formBackgrounds}
                onFinish={onFinishBackgrounds}
                colon={false}
                labelCol={{ span: 24, style: { fontWeight: 700 } }}
                wrapperCol={{ span: 24 }}

            >
                <Form.Item hidden name="ID">
                    <Input />
                </Form.Item>
                <Form.Item label="Màu chữ" name="Color">
                    <HexColorPicker
                        color={formBackgrounds.getFieldValue("Color")}
                        onChange={(newColor) => {
                            formBackgrounds.setFieldsValue({ Color: newColor });
                        }}
                    />
                </Form.Item>


                {/* Logo 1 ảnh */}
                <Form.Item label="Logo" name="Logo">
                    <Upload
                        listType="picture-card"
                        maxCount={1}
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        fileList={fileList}
                        onChange={(info) =>
                            changeUpload(formBackgrounds, "Logo", info, setFileList)
                        }
                    >
                        <PlusOutlined />
                    </Upload>
                </Form.Item>

                {/* Ảnh nền 1 ảnh */}
                <Form.Item label="Ảnh nền" name="Image">
                    <Upload
                        listType="picture-card"
                        maxCount={1}
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        fileList={fileListBackgrounds}
                        onChange={(info) =>
                            changeUpload(formBackgrounds, "Image", info, setFileListBackgrounds)
                        }
                    >
                        <PlusOutlined />
                    </Upload>
                </Form.Item>
                <Form.Item
                    label="Ghi chú"
                    name="Note"
                    rules={[{ required: true, message: "Nhập nội dung chữ chạy" }]}
                >
                    <Input.TextArea rows={3} />
                </Form.Item>
                <Form.Item
                    label="Kích hoạt"
                    name="IsActive"
                    valuePropName="checked"   // bắt buộc cho Switch
                >
                    <Switch />
                </Form.Item>
            </Form>
        );
    };
    const formatNote = (text) => {
        if (!text) return "";
        return text.split("\n").map((line, i) => (
            <div key={i}>{line}</div>
        ));
    };

    const DeleteBackgrounds = (record) => {
        if (record.ID !== 0) {
            swal({
                title: "Bạn có muốn xóa băng rôn này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/Backgrounds/DeleteBackgrounds/${record.ID}`, record.ID, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataBackgrounds(); // Tải lại dữ liệu sau khi xóa
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const columnBackgrounds = [

        {
            title: <div style={{ textAlign: "center" }}>Logo</div>,
            dataIndex: "Logo",
            width: 100,
            align: 'center',
            render: (img) => {
                console.log(LinkUpload(img))
                return (
                    <Image width={50} src={LinkUpload(img)} />
                )
            }
        },
        {
            title: <div style={{ textAlign: "center" }}>Ảnh nền</div>,
            dataIndex: "Image",
            width: 100,
            align: 'center',
            render: (img) => (
                <Image width={80} src={LinkUpload(img)} />
            )
        },
        {
            title: <div style={{ textAlign: "center" }}>Nội dung</div>,
            dataIndex: "Note",
            width: 400,
            render: (text) => (
                <div style={{ fontSize: 13 }}>{formatNote(text)}</div>
            )
        },
        {
            title: <div style={{ textAlign: "center" }}>Màu chữ</div>,
            dataIndex: "Color",
            width: 100,
            align: 'center',
            render: (color) => (
                <Tag color={color} style={{ color: "#000" }}>
                    {color}
                </Tag>
            )
        },
        {
            title: <div style={{ textAlign: "center" }}>Kích hoạt</div>,
            dataIndex: "IsActive",
            width: 100,
            align: 'center',
            render: (active) =>
                active ? (
                    <Tag color="green">Đang dùng</Tag>
                ) : (
                    <Tag color="red">Tắt</Tag>
                )
        },
        {
            title: <div style={{ textAlign: "center" }}><SettingOutlined /></div>,
            width: 80,
            align: 'center',
            render: (_, record) => (
                <Space>
                    <Button
                        icon={<FormOutlined style={{ color: "#1890ff" }} />}
                        onClick={() => showModalBackgrounds(record)}
                    />
                    {/* <Button
                        icon={<DeleteOutlined style={{ color: "red" }} />}
                        onClick={() => DeleteBackgrounds(record)}
                    /> */}
                </Space>

            )
        }
    ];

    useEffect(() => {

        LoadDataPermission()
        LoadDataBackgrounds();

    }, [])


    const handleCancelBackgrounds = () => {
        setLoadingBackgrounds(false);
        setOpenModalBackgrounds(false);
    }
    const handleOkBackgrounds = () => {
        setTimeout(() => {
            setLoadingBackgrounds(false);
            setOpenModalBackgrounds(false);
        }, 3000);
    }


    return (
        <div>
            <Card size="small">
                <Tabs type="card"
                    tabBarGutter={10}
                    tabPosition="top" // Hiển thị tabs theo chiều ngang
                    tabBarStyle={{ backgroundColor: "#D6E4FF", borderRadius: "8px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)" }}
                    moreIcon={null} >

                    <TabPane tab="Banner" key="1">
                        <Row gutter={16}>
                            {/* <Col span={24}>
                                <Form id="form-filter-Backgrounds" form={formFilterBackgrounds}>
                                    <Row gutter={[8, 8]}>
                                        <Col xs={24} xl={24} span={4}>
                                            <Button key={1} onClick={(e) => showModalBackgrounds(0, e)} style={{ backgroundColor: '#00CC99', color: 'white', minWidth: 100, borderRadius: 5 }} icon={<PlusOutlined style={{ color: 'white' }} />}>
                                                Thêm mới
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col> */}
                            <Col xs={24} xl={24} span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} scroll={{ x: 1000 }} size="middle" dataSource={dataBackgrounds} pagination={{ pageSize: 10 }} sticky columns={columnBackgrounds} />
                            </Col>
                        </Row>
                    </TabPane>

                </Tabs>
            </Card>

            <Modal
                width={600}
                onOk={handleOkBackgrounds}
                onCancel={handleCancelBackgrounds}
                open={openModalBackgrounds}
                title={
                    <span>
                        {statusBackgrounds === false ? 'Thêm mới băng rôn' : 'Cập nhật băng rôn'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelBackgrounds} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Backgrounds" type="primary" htmlType="submit" loading={loadingBackgrounds}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingBackgrounds ? (
                    <>
                        <Skeleton loading={loadingBackgrounds} active />
                    </>
                ) : (
                    <>{renderBackgrounds()}</>
                )}
            </Modal>


        </div >
    )

}
export default MarqueeManager;